var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom_sheet",style:({
	height: (_vm.currentHeight + "px"),
	transition: _vm.isDragging ? 'none' : 'height 0.3s ease'
})},[_c('div',{staticClass:"bottom_sheet_header",on:{"mousedown":_vm.startDrag,"touchstart":_vm.startDrag}},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"bottom_sheet_content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f10bf18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ai/AiBottomSheet.vue
// module id = null
// module chunks = 